import { NgModule } from '@angular/core';
import { PaymentButtonSharedComponent } from './components';
import { TranslateModule } from '@ngx-translate/core';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { MutualModule } from '@shared/mutual/mutual.module';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [PaymentButtonSharedComponent],
  imports: [CommonModule, MutualModule, TranslateModule, PipesSharedModule],
  exports: [PaymentButtonSharedComponent],
})
export class PaymentButtonSharedModule {}
